import { render, staticRenderFns } from "./RotasPage.vue?vue&type=template&id=2cd8eb1a"
import script from "./RotasPage.vue?vue&type=script&lang=js"
export * from "./RotasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports